import { clientFetch } from 'app/utils/client-fetch';
import * as types from './types';
import config from 'app/config';

export const apiGetLocales = () => {
    return clientFetch( {
        url: `${ config.CMX_API_URL }/locales`,
        type: types.GET_LOCALES
    } );
};

export const apiGetPrivacyFiles = privacyId => {
    return clientFetch( {
        url: `${ config.PRIVACY_API_URL }/files/${ privacyId }`,
        type: types.GET_PRIVACY_FILES
    } );
};

const arrayBufferToBase64 = buffer => {
    let binary = '';
    const bytes = new Uint8Array( buffer );
    const len = bytes.byteLength;
    for ( let i = 0; i < len; i++ ) {
        binary += String.fromCharCode( bytes[ i ] );
    }
    return window.btoa( binary );
};

export const apiPostPrivacyFiles = async ( privacyId, body ) => {
    let files = body.files;
    files = await files.map( file => ( { ...file, file: arrayBufferToBase64( file.file ) } ) );
    body = { ...body, files };
    return clientFetch( {
        url: `${ config.PRIVACY_API_URL }/files/${ privacyId }`,
        type: types.GET_PRIVACY_FILES,
        method: 'post',
        body
    } );
};

export const apiGetPrivacyFile = async resource =>
    await clientFetch( {
        url: `${ config.PRIVACY_DOWNLOAD_API_URL }${ resource }`,
        headers: {
            Accept: 'application/pdf'
        }
    } );

export const apiPostNavigationBundle = async () => {
    return await clientFetch( {
        url: `${ config.CMX_API_URL }/bundle/navigation`,
        method: 'POST',
        body: JSON.stringify( { locale: 'en-US' } )
    } );
};
